import { ReadReportDeviceUnderTestAssignmentsReply } from "@/backend/express/controllers/reportDeviceUnderTestController";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class ReportDeviceUnderTestFrontendController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  getReportDevicesUnderTest(reportId: string): Promise<ReadReportDeviceUnderTestAssignmentsReply> {
    return this.client.read(`/api/report-device-under-test/${reportId}`);
  }

  importDeviceUnderTestForProcedure(procedureId: string, reportId: string): Promise<FusaReply> {
    return this.client.create(`/api/report-device-under-test/importForProcedure`, { procedureId, reportId });
  }

  removeDeviceUnderTestFromReport(reportId: string, partId: string): Promise<FusaReply> {
    return this.client.create(`/api/report-device-under-test/removeFromReport`, { reportId, partId });
  }
}
